export default __webpack_public_path__ + "static/media/it.41aff9c7.svg";